import { debug, Formsy, george, observer, pr, React, theme, ui } from "aaa";
import { CardWithIconAndText } from "components/common/CardWithIconAndText";
import { useEffect, useState } from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import trackingStore from "stores/TrackingStore";
import { ICreditCardOfferDetails } from "types/offer";
import { isInRange, isInteger } from "util/formValidations";
import { ChooseLimitResponsive } from "../common/ChooseLimit";
import { CreditCardBusinessStore } from "./CreditCardBusinessStore";
import { ShopCreditCardBusinessRoutes } from "./ShopCreditCardBusinessRoutes";


const ChooseCardCharacteristic = observer(({ store }: ShopCreditCardBusinessCardInfoProps) => {

    const sectionSubtitle = store.isMilesAndMoreCreditCard
        ? ui.__("shop.cardInfo.variant.message.milesAndMore")
        : ui.__("shop.creditCardBusiness.cardVariant.message");

    return (
        <div style={{ padding: theme.MARGIN }}>
            <george.SectionTitle style={{ marginTop: 0 }}>
                {ui.__("shop.creditCardBusiness.cardVariant.title")}
            </george.SectionTitle>
            <george.SectionSubtitleTop>
                {sectionSubtitle}
            </george.SectionSubtitleTop>
            <pr.HFlex style={{ justifyContent: "space-evenly", flexWrap: "wrap" }}>
                <div style={{ width: 290, textAlign: "center", marginTop: theme.MARGIN }}>
                    <CardWithIconAndText
                        checked={store.cardCharacteristic === "regular"}
                        onClick={async () => {
                            await trackingStore.trackEvent({ eventName: "cardCharacteristicRegularSet" });
                            store.cardCharacteristic = "regular";
                        }}
                        aria-label={ui.__("a11y.regularCreditCard")}
                        text={ui.__("shop.cardInfo.cardCharacteristic.regular")}
                        icon={(
                            <pr.IconCreditCardXL
                                style={{
                                    width: 48,
                                    height: 48,
                                    color: store.cardCharacteristic === "regular" ? theme.customColors.georgeLightBlue : theme.customColors.georgeLightGrey
                                }}
                            />
                        )}
                    />
                    <pr.P_14_CONTENT style={{ marginTop: theme.MARGIN_SMALL }}>{ui.__("shop.cardInfo.cardCharacteristic.regular.message")}</pr.P_14_CONTENT>
                </div>
                {store.offerDetails && (store.offerDetails as ICreditCardOfferDetails).zeroLimitCardSupported &&
                    <div style={{ width: 290, textAlign: "center", marginTop: theme.MARGIN }}>
                        <CardWithIconAndText
                            checked={store.cardCharacteristic === "prepaid"}
                            onClick={async () => {
                                await trackingStore.trackEvent({ eventName: "cardCharacteristicPrepaidSet" });
                                store.cardCharacteristic = "prepaid";
                            }}
                            aria-label={ui.__("a11y.prepaidcreditCard")}
                            text={ui.__("shop.cardInfo.cardCharacteristic.prepaid")}
                            icon={(
                                <pr.IconPrepaidCardXL
                                    style={{
                                        width: 48,
                                        height: 48,
                                        color: store.cardCharacteristic === "prepaid" ? theme.customColors.georgeLightBlue : theme.customColors.georgeLightGrey
                                    }}
                                />
                            )}
                        />
                        <pr.P_14_CONTENT style={{ marginTop: theme.MARGIN_SMALL }}>{ui.__("shop.cardInfo.cardCharacteristic.prepaid.message")}</pr.P_14_CONTENT>
                    </div>
                }
            </pr.HFlex>
        </div>
    );
});

const ChooseRepaymentMethod = observer(({ store }: ShopCreditCardBusinessCardInfoProps) => {
    const revolvingAllowed = store.offerDetails && (store.offerDetails as ICreditCardOfferDetails).revolving;
    debug.log("### revolvingAllowed", revolvingAllowed);

    return (
        <>
            <div style={{ padding: theme.MARGIN }}>
                <george.SectionTitle style={{ marginTop: 0 }}>
                    {ui.__("shop.cardInfo.repayment.title")}
                </george.SectionTitle>

                <pr.HFlex style={{ justifyContent: "space-evenly", flexWrap: "wrap" }}>
                    {/* Select charge card */}
                    <div style={{ width: 290, textAlign: "center", marginTop: theme.MARGIN }}>
                        <CardWithIconAndText
                            checked={store.repaymentChargeCard}
                            onClick={async () => {
                                await trackingStore.trackEvent({ eventName: "repaymentMethodChargeSet" });
                                store.repaymentChargeCard = true;
                            }}
                            aria-label={ui.__("a11y.monthlyFullPayment")}
                            text={ui.__("shop.cardInfo.repayment.chargeCard")}
                            icon="#ico-circle-stripes"
                        />
                        <pr.P_14_CONTENT style={{ marginTop: theme.MARGIN_SMALL }}>{ui.__("shop.cardInfo.repayment.chargeCard.message")}</pr.P_14_CONTENT>
                    </div>


                    {/* Select revolving */}
                    {revolvingAllowed &&
                        <div style={{ width: 290, textAlign: "center", marginTop: theme.MARGIN }}>
                            <CardWithIconAndText
                                checked={!store.repaymentChargeCard}
                                onClick={async () => {
                                    await trackingStore.trackEvent({ eventName: "repaymentMethodRevolvingSet" });
                                    store.repaymentChargeCard = false;
                                }}
                                aria-label={ui.__("a11y.monthlyPartPayment")}
                                text={ui.__("shop.cardInfo.repayment.revolving")}
                                icon="#ico-circle-pie"
                            />
                            <pr.P_14_CONTENT style={{ marginTop: theme.MARGIN_SMALL }}>{ui.__("shop.cardInfo.repayment.revolving.message")}</pr.P_14_CONTENT>
                        </div>
                    }
                </pr.HFlex>
            </div>

            {/* Revolving parameters */}
            {!store.repaymentChargeCard &&
                <div>
                    <>
                        <pr.LightSeparatorLine spacing={theme.MARGIN} />
                        <div style={{ padding: theme.MARGIN }}>
                            <george.SectionTitle style={{ marginTop: 0 }}> {ui.__("shop.cardInfo.repayment.revolving.percent")}</george.SectionTitle >
                            <george.SectionSubtitleTop>{ui.__("shop.cardInfo.repayment.revolving.info")}</george.SectionSubtitleTop>
                            <george.ResponsiveFormElement label={ui.__("shop.cardInfo.repayment.revolving")}>
                                <george.TextFieldFormsy
                                    name="revolvingPercentage"
                                    required
                                    validations="isNumeric,isInRange:[10, 50]"
                                    validationError={ui.__("value.invalid")}
                                    value={store.revolvingPercentage !== 0 ? store.revolvingPercentage : ""}
                                    inputValidations={[isInteger, isInRange(0, 50)]}
                                    decorator="%"
                                    aria-label={ui.__("shop.cardInfo.repayment.revolving.percent")}
                                    centered
                                    inputMode="decimal"
                                />
                            </george.ResponsiveFormElement>
                        </div>
                    </>

                    <pr.LightSeparatorLine spacing={theme.MARGIN} />
                    <div style={{ padding: theme.MARGIN }}>
                        <>
                            <george.SectionTitle style={{ marginTop: 0 }}>
                                {ui.__("shop.cardInfo.repayment.minRate")}
                            </george.SectionTitle>
                            <george.SectionSubtitleTop>{ui.__("shop.cardInfo.repayment.minRate.info")}</george.SectionSubtitleTop>
                        </>
                        <george.ResponsiveFormElement label={ui.__("common.minRate")}>
                            <george.TextFieldFormsy
                                name="revolvingMinRate"
                                required
                                inputValidations={[isInteger, isInRange(0, 1000)]}
                                validations="isNumeric,isInRange:[50, 1000]"
                                validationError={ui.__("value.invalid")}
                                value={store.revolvingMinRate !== 0 ? store.revolvingMinRate : ""}
                                decorator="EUR"
                                aria-label={ui.__("a11y.minRateInEUR")}
                                centered
                                inputMode="decimal"
                            />
                        </george.ResponsiveFormElement>
                    </div>
                </div>
            }
        </>
    );
});

type ShopCreditCardBusinessCardInfoProps = {
    store: CreditCardBusinessStore;
}

export const ShopCreditCardBusinessCardInfo = observer(({ store }: ShopCreditCardBusinessCardInfoProps) => {
    const [isFormValid, setIsFormValid] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const buttonDisabled = store.isLoading ||
        (store.contactsStore.watchdogActive && !store.contactsStore.selectedPhoneId) ||
        (isFormValid === false && store.repaymentChargeCard === false);

    const PageComponent = externalInterfaceStore.isGeorgeApp ? george.PageWithActionButton : React.Fragment;

    const limitDescription = store.productName ? ui.__("shop.creditCardBusiness.cardLimit.message", { product: store.productName }) : ui.__("shop.creditCardBusiness.cardLimit.message.generic");

    const handleSubmit = async (values: any) => {
        debug.log("### repaymentChargeCard", store.repaymentChargeCard);
        debug.log("###", values);
        debug.log("### limit", store.limitsStore.selectedLimit);
        debug.log("### watchdog", store.contactsStore.watchdogActive, store.contactsStore.selectedPhone);

        store.revolvingPercentage = values.revolvingPercentage || 0;
        store.revolvingMinRate = values.revolvingMinRate || 0;
        await trackingStore.trackEvent({ eventName: "nextPage" });
        pushRoute(ShopCreditCardBusinessRoutes.SUMMARY);
    }

    const handleSetValid = () => setIsFormValid(true);
    const handleSetInvalid = () => setIsFormValid(false);


    return (
        <george.Background>
            <PageComponent>
                <george.Card>
                    <Formsy.Form
                        onValid={handleSetValid}
                        onInvalid={handleSetInvalid}
                        onValidSubmit={handleSubmit}
                        onInvalidSubmit={handleSubmit}
                    >

                        <ChooseCardCharacteristic store={store} />

                        {store.cardCharacteristic === "regular" && (
                            <>
                                <pr.LightSeparatorLine spacing={theme.MARGIN} />
                                <div style={{ padding: theme.MARGIN }}>
                                    <ChooseLimitResponsive
                                        store={store.limitsStore}
                                        description={limitDescription}
                                    />
                                </div>
                            </>
                        )}

                        {store.cardCharacteristic !== "prepaid" &&
                            <>
                                <pr.LightSeparatorLine spacing={theme.MARGIN} />
                                <ChooseRepaymentMethod store={store} />
                            </>
                        }
                        {!externalInterfaceStore.isGeorgeApp &&
                            <pr.LightSeparatorLine spacing={theme.MARGIN} />
                        }

                        <george.ActionButton
                            messageId={store.isLoading ? undefined : "button.continue"}
                            disableButton={buttonDisabled}
                            isLoading={store.isLoading}
                            submit
                            onClick={() => {/* handled by onSubmit */ }}
                            {...george.getActionButtonWebVersionProps()}
                        />
                    </Formsy.Form>
                </george.Card>
            </PageComponent>
        </george.Background>
    );
});



// WEBPACK FOOTER //
// ./src/components/shopCreditCardBusiness/ShopCreditCardBusinessCardInfo.tsx